































































































































import { Component, Vue } from 'vue-property-decorator';
import HulaTry from '@/components/hula-try/index.vue';
import HulaFixBanner from '@/components/hula-fix-banner/index.vue';

@Component({
  name: 'Safety',
  components: { HulaFixBanner, HulaTry }
})
export default class Safety extends Vue {
  public tabFixed = false
  public introduceHeight: number[] = []
  public currentIndex = 0
  public tabList = [
    {
      name: '巡检计划'
    },
    {
      name: '执行清单'
    },
    {
      name: '异常报事'
    },
    {
      name: '临时任务'
    },
    {
      name: '值班日志'
    }
  ]

  public mounted () {
    this.$bus.$on('scroll', this.getBannerHeight);
  }

  public beforeDestroy () {
    this.$bus.$rm('scroll', this.getBannerHeight);
  }

  public getHeight () {
    const uls = document.querySelectorAll<HTMLDivElement>('.hula-introduce .safety');
    this.introduceHeight = Array.from(uls).map((ul) => this.windowWidth >= 700 ? ul.offsetTop - 56 : ul.offsetTop - 62);
  }

  public getElementsScroll () {
    // const element = document.querySelector<HTMLDivElement>('.hula-tab');
    const scrollElement = document.querySelector<HTMLDivElement>('.hula-tab-wrapper');
    const items = document.querySelectorAll<HTMLDivElement>('.hula-tab-item');
    const rightDt = items[this.currentIndex].offsetLeft + items[this.currentIndex].getBoundingClientRect().width;
    if (rightDt - (scrollElement!.scrollLeft + scrollElement!.getBoundingClientRect().width) > 0) {
      scrollElement!.scrollLeft = rightDt - scrollElement!.getBoundingClientRect().width + 10;
    }
    const delta = scrollElement!.scrollLeft - items[this.currentIndex].offsetLeft;
    if (delta > 0) {
      scrollElement!.scrollLeft -= delta + 20;
    }
  }

  public getBannerHeight () {
    this.getHeight();
    this.getElementsScroll();
    const div = document.querySelector('.layouts--main');
    if (div) {
      this.tabFixed = div.scrollTop >= 350;
      if (div.scrollTop < this.introduceHeight[0]) {
        this.currentIndex = 0;
        return;
      }
      const index = this.introduceHeight.findIndex(it => it > div.scrollTop);
      this.currentIndex = index < 0 ? this.introduceHeight.length - 1 : index - 1;
    }
  }

  public getItemTop (index: number) {
    this.getHeight();
    this.getElementsScroll();
    const div = document.querySelector('.layouts--main');
    this.currentIndex = index;
    if (div) {
      div.scrollTop = this.introduceHeight[index];
    }
  }
}
